<template>
  <div class="wrap">
    <div class="container lnb">
      <div class="contents_wrap">
        <div class="contents" style="min-height:0px;">
          <el-form label-width="120px" class="demo-ruleForm">

            <el-form-item label="답변 받을 이메일">
              <el-input v-model="qq_email" readonly></el-input>
            </el-form-item>
            <el-form-item label="제목">
              <el-input v-model="qq_subject" readonly></el-input>
            </el-form-item>
            <el-form-item label="내용">
              <el-input type="textarea" id="qq_content"  v-model="qq_content" readonly >
              </el-input>
            </el-form-item>
          </el-form>
          <div
               v-for="(file, index) in  files"
               :key="index"
          >
            <img :src="`http://${file.thumb_url}`" style="max-height:300px;display:inline-block;float:left; margin-right:10px;">
          </div>
        </div>

        <div class="contents" style="clear:both;">
          <el-form :model="ruleForm" :rules="rules" ref="ruleForm" label-width="120px" class="demo-ruleForm">
            <el-form-item label="답변 제목" prop="qa_subject">
              <el-input v-model="ruleForm.qa_subject" ></el-input>
            </el-form-item>
            <el-form-item label="답변 내용" prop="qa_content">
              <el-input type="textarea" id="qa_content"  v-model="ruleForm.qa_content"  >
              </el-input>
            </el-form-item>
            <el-form-item class="text-center">
              <el-button type="primary" @click="submitForm('ruleForm')">{{ qq_status === 1 ? '수정' : '등록' }}</el-button>
              <el-button @click="resetForm('ruleForm')">목록 </el-button>
            </el-form-item>
          </el-form>
        </div>
        <page-footer></page-footer>
      </div>
    </div>
  </div>
</template>

<script>
  import VuxAlert from '@/mixins/vux-alert';
  import util from '@/mixins/util';
  import sessionStorage from '@/mixins/sessionStorage';
  import {countryList} from "@/service/countryService";

  let params = {};
  export default {
    name: "QaDetail",
    components: {},
    mixins: [ VuxAlert,sessionStorage ],
    data() {
      return {
        qq_idx : this.$route.params.qq_idx,
        c_idx : 1,
        category : [],
        categoryData : [],
        qq_subject : '',
        qq_content : '',
        qq_name : '',
        qq_status : '',
        qq_email : '',
        files : [],
        ruleForm: {
          qa_idx: '',
          qa_content: '',
          qa_subject: ''
        },
        rules: {
          qa_content: [
            { required: true, message: '필수 선택사항입니다.', trigger: 'blur' },
          ],
          qa_subject: [
            { required: true, message: '필수 입력사항입니다.', trigger: 'blur' }
          ],
        }
      };
    },
    mounted() {
      this.getCountryList();
      this.getQaDetail();
    },

    methods: {
      getCountryList(){
        this.$api.$user.getCountry()
          .then(res => { // 로그인 api 통신 후 결과 처리
            //let resultData = res.Data.result;
            // this.category = [{c_idx : 1 , CO_NAME_KOR : 'South Korea'},{c_idx : 2 , CO_NAME_KOR : 'Japan'}];
            this.category = countryList;
          });
      },
      getQaDetail(){

        if(this.qq_idx){
          const params = {  id : this.qq_idx , qq_type : 'member',opd:1,opf:1}
          this.$api.$board.getQaList(params).then( res => res.Data.Result).then(res => {
            if(res.Info.Type === 1){
              this.qq_subject = res.List[0].qq_subject;
              this.qq_content = res.List[0].qq_content;
              this.qq_name = res.List[0].mb_name;
              this.qq_status = res.List[0].qq_status;
              this.qq_email = res.List[0].qq_email;
              if(this.qq_status === 1) {
                this.ruleForm =  {
         /*         qa_idx: res.List[0].Answer.List[0].qa_idx,
                  qa_subject: res.List[0].Answer.List[0].qa_subject,
                  qa_content: res.List[0].Answer.List[0].qa_content*/
                }
              }
              if(res.List[0].QuestionFile.length > 0){
                this.files = res.List[0].QuestionFile;
              }
              this.c_idx = res.List[0].c_idx;
            }
          })
        }
      },

      reFormDate (date) {
        //2019.02.15
        return this.$_.replace(date.split(' ')[0], /-/gi, '.')
      },

      submitForm(formName) {
        this.$refs[formName].validate((valid) => {
          if (valid) {
            params = {
              qa_subject : this.ruleForm.qa_subject ,
              qa_content : this.ruleForm.qa_content,
              type : 1,
              qa_type : 'answer',
            }
            if(this.qq_status ===2){
              params.qa_idx = this.ruleForm.qa_idx;
              this.$api.$board.updateQa(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  this.updateAlert();
                }else{
                  this.errorAlert(res.reason);
                }
              })
            }else{
              params.qq_idx   = this.qq_idx ;
              this.$api.$board.setQaAnswer(params).then( res => res.Data.Result).then(res => {
                if(res.Info.Type === 1){
                  let alertParams = {'element' : this };
                  this.saveAlert(alertParams);
                }else{
                  this.errorAlert(res.reason);
                }
              })
            }
          } else {
            this.validateAlert();
            return false;
          }
        });
      },
      resetForm(formName) {
        window.history.back();
    }
    }
  }
</script>
